<template>
  <div class="row page-content-wrapper">
    <div class="col-12">
      <page-header>
        <template slot="action-buttons">
          <a class="zip-link" :href="`${localBasePath}/api/v1/reports/report/${report.id}/zip?authorization=${access_token_link}`" target="_blank">
            {{ 'Download zip' | i18n }}
          </a>
        </template>
      </page-header>
      <div class="row">
        <div class="col-12 main-content">
          <div id="header">
            <div class="customer-logo-header">
              <div class="customer-logo-wrapper">
                <img
                  :style="`max-width: 100%; max-height:50px; height:${imageHeight}px;`"
                  :src="`${localBasePath}/api/v1/static/pdf-templates/companyLogo.png`"
                />
              </div>
              <img :src="reportsIcon" class="reports-logo" />
            </div>
            <div class="date-text">
              {{ date }}
            </div>
            <div class="report-text">
              <h3 class="report-title">{{ report.title }} / Report #: {{ report.caseNumber }}</h3>
              <div class="user-block">Person: {{ report.user.name }} ({{ report.user.email }})</div>
            </div>
          </div>
          <div v-for="group in groups" :key="group.group.id" class="group-block">
            <div class="group-name-block">
              <div class="group-name">
                {{ group.group.groupName }}
              </div>
              <span v-if="group.group.groupComment" class="group-comment">{{ group.group.groupComment }}</span>
            </div>
            <div class="group-content">
              <div v-for="(masonry2, masonry2Name) in group.data.masonry2" :key="masonry2Name" class="masonry-2">
                <div v-for="item in masonry2" :key="item.key" class="item">
                  <div>
                    <span class="group-field-name">{{ item.title }}:</span><span class="group-field-content">{{ item.value }}</span>
                    <div>
                      <span class="group-field-name" v-if="item.showTextInput">{{ item.textInputName }}:</span
                      ><span class="group-field-content">{{ item.textInputValue }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="masonry-3">
                <div v-for="item in group.data.checkboxs" :key="item.title" class="item">
                  <span class="group-field-name">{{ item.title }}: </span>
                  <span class="group-field-content"><input type="checkbox" :checked="item.value === 'true'" /> </span>
                </div>
              </div>
              <div class="masonry-3">
                <div v-for="item in group.data.multipleCheckbox" :key="item.title" class="item">
                  <span class="group-field-name">{{ item.title }}:</span>
                  <span class="group-field-content">
                    <div v-for="c in item.mappedValues" :key="c.key"><input type="checkbox" :checked="item.value[c.key]" /> {{ c.value }}</div>
                  </span>
                </div>
              </div>
              <div class="masonry-3">
                <div v-for="item in group.data.radioButton" :key="item.title" class="item">
                  <span class="group-field-name">{{ item.title }}:</span>
                  <span class="group-field-content">
                    <div v-for="c in item.mappedValues" :key="c.key">
                      <input type="radio" :checked="item.value === c.key" :value="c.value" :name="item.key" style="margin-right: 15px" />{{ c.value }}
                    </div>
                  </span>
                </div>
              </div>
              <div class="masonry-3">
                <div v-for="item in group.data.medias" :key="item.title" class="item">
                  <span class="group-field-name">{{ item.title }}:</span><img :src="item.link" />
                  <a :href="item.link" target="_blank">(Download)</a>
                </div>
                <div v-for="item in group.data.files" :key="item.title" class="item">
                  <span class="group-field-name">{{ item.title }}:</span>
                  <div>
                    <a :href="item.link" target="_blank">(Download)</a>
                  </div>
                </div>
              </div>
              <div v-for="feed in group.data.feeds" :key="feed.id">
                <span class="group-multimedia-name">{{ feed.title }}</span>
                <div class="multimedia-content">
                  <div v-for="msg in feed.messages" :key="msg.key" class="multimedia-line">
                    <span v-if="msg.type === 'image'">
                      <div class="multimedia-line-type" />
                      <div class="multimedia-line-mylti-photo">
                        <span>
                          <img v-if="msg.link" :src="msg.link" />
                          <a v-if="msg.link" :href="msg.link" target="_blank">(Download)</a>
                        </span>
                      </div>
                    </span>
                    <span v-if="msg.type === 'textImage'">
                      <div class="multimedia-line-text">{{ msg.message }}</div>
                      <div class="multimedia-line-photo">
                        <span>
                          <img v-if="msg.link" :src="msg.link" />
                          <a v-if="msg.link" :href="msg.link" target="_blank">(Download)</a>
                        </span>
                      </div>
                    </span>
                    <span v-if="msg.type === 'images'">
                      <div class="multimedia-line-type" />
                      <div class="multimedia-line-mylti-photo">
                        <span v-for="l in msg.links" :key="l">
                          <img :src="l" />
                          <a :href="l" target="_blank">(Download)</a>
                        </span>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
              <div class="masonry-3">
                <div v-for="item in group.data.signatures" :key="item.title" class="item">
                  <span class="group-field-name">{{ item.title }}:</span><img :src="item.link" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';

import { ReportsMixin, NotificationMixin, BaseTableComponentMixin, DeleteRowMixin, AuthMixin, ApiMixin, AuthStorageMixin } from '../../../mixins';
import DataTable from '../../table/data-table';
import PageHeader from '../../../v2/components/common/page-header';
import { BBadge } from 'bootstrap-vue';
import constants from '../../../../../../constants';
import TableFiler from '../../table/table-filter';
import reportsIcon from '../../../assets/reports.png';

export default {
  name: 'Cases',
  components: { PageHeader, DataTable, BBadge, TableFiler },
  mixins: [ReportsMixin, NotificationMixin, BaseTableComponentMixin, DeleteRowMixin, AuthMixin, ApiMixin, AuthStorageMixin],
  data: function () {
    return {
      report: {
        user: {},
      },
      groups: [],
      reportsIcon: reportsIcon,
      date: moment().format('DD.MM.YYYY'),
      imageHeight: 0,
      content: '',
      access_token_link: '',
    };
  },
  computed: {
    localBasePath: function () {
      return axios.defaults.baseURL;
    },
  },
  async created() {
    const auth = this.authStorageService.getAuth();
    this.access_token_link = auth.access_token_link;

    const t = this;
    const img = new Image();

    img.onload = function () {
      t.imageHeight = this.height;
    };

    img.src = `${this.localBasePath}/api/v1/static/pdf-templates/companyLogo.png`;

    const report = await this.getReport();
    const reportData = report.data;

    const groups = reportData.template.groups;
    const groupsField = {};
    groups.forEach((item) => {
      groupsField[item.id] = {
        groupName: item.name,
        groupComment: item.comment,
        content: [],
      };
    });
    reportData.template.fields.forEach((item) => {
      const value = item.editByMobile ? reportData.report.fields[item.key] : reportData.fields[item.key];
      groupsField[item.groupId].content.push({ ...item, value });
    });

    for (const item of Object.values(groupsField)) {
      const content = await this.generateGroup(item, reportData);
      this.groups.push(content);
    }
  },
  methods: {
    async translate(text, ln, needTranslate) {
      return text;
    },
    async generateGroup(group, report) {
      const data = await this.generateGroupContent(group.content, report);
      return {
        group,
        data,
      };
    },
    async generateGroupContent(content, report) {
      const ENTRY_TYPES = constants.ENTRY_TYPES;

      const textFields = [];
      const formulaFields = [];
      const locationFields = [];
      const checkboxFields = [];
      const multipleCheckboxFields = [];
      const radioButtonFields = [];
      const mediaFields = [];
      const signatureFields = [];
      const fileFields = [];
      const feedFields = [];
      const timeFields = [];
      const dateTimeFields = [];
      const textBlockFields = [];

      const localBasePath = this.localBasePath;

      content.forEach((item) => {
        switch (item.entryType) {
          case ENTRY_TYPES.TEXT:
            textFields.push(item);
            break;
          case ENTRY_TYPES.TEXT_BLOCK:
            textBlockFields.push(item);
            break;
          case ENTRY_TYPES.BAR_CODE:
            textBlockFields.push(item);
            break;
          case ENTRY_TYPES.LOCATION:
            locationFields.push(item);
            break;
          case ENTRY_TYPES.CHECKBOX:
            checkboxFields.push(item);
            break;
          case ENTRY_TYPES.MULTIPLE_CHECKBOXES:
            multipleCheckboxFields.push(item);
            break;
          case ENTRY_TYPES.RADIO_BUTTON:
            radioButtonFields.push(item);
            break;
          case ENTRY_TYPES.MULTILINE_TEXT:
            textFields.push(item);
            break;
          case ENTRY_TYPES.QR_CODE:
            textFields.push(item);
            break;
          case ENTRY_TYPES.FORMULA:
            formulaFields.push(item);
            break;
          case ENTRY_TYPES.INT:
            textFields.push(item);
            break;
          case ENTRY_TYPES.DECIMAL:
            textFields.push(item);
            break;
          case ENTRY_TYPES.DROPDOWN:
            textFields.push(item);
            break;
          case ENTRY_TYPES.TIME:
            timeFields.push(item);
            break;
          case ENTRY_TYPES.DATE:
            textFields.push(item);
            break;
          case ENTRY_TYPES.DATE_TIME:
            dateTimeFields.push(item);
            break;
          case ENTRY_TYPES.FILE:
            fileFields.push(item);
            break;
          case ENTRY_TYPES.PHOTO:
            mediaFields.push(item);
            break;
          case ENTRY_TYPES.DRAWING:
            mediaFields.push(item);
            break;
          case ENTRY_TYPES.PICTURE_IN_TEMPLATE:
            mediaFields.push(item);
            break;
          case ENTRY_TYPES.SIGNATURE:
            signatureFields.push(item);
            break;
          case ENTRY_TYPES.FEED:
            feedFields.push(item);
            break;
        }
      });
      let html = '';

      multipleCheckboxFields.forEach((c) => {
        c.value = c.value ? JSON.parse(c.value) : {};
      });

      const getValueTextBlock = (item) => {
        const obj = item.mappedValues.find((i) => i.key === item.value) || null;
        if (obj && obj.value) {
          return obj.value;
        } else {
          return '';
        }
      };

      const getFormulaText = (item) => {
        return `${Number(item.value) * Number(item.unitValue)} ${item.unitName}`;
      };

      const getValueTime = (i) => {
        const value = i.value ? JSON.parse(i.value) : {};
        const formatT = (t) => {
          const numberTime = Number(t);
          if (numberTime < 10) {
            return `0${numberTime}`;
          }
          return numberTime;
        };

        return `${formatT(value.hours)}:${formatT(value.minutes)}`;
      };

      const getValueDateTime = (item) => {
        const offset = moment.parseZone(item.value).utcOffset() / 60;
        return `${moment(item.value).format('YYYY-MM-DD HH:mm')} (UTC ${offset >= 0 ? '+' : ''} ${offset})`;
      };

      const getValueLocation = (item) => {
        const value = item.value ? JSON.parse(item.value) : {};
        return `Address: ${value.address || 'Not filled'}, Latitude: ${value.lat || 'Not filled'}, Longitude: ${value.lon || 'Not filled'}`;
      };

      let masonry2 = [
        textFields.map(({ title, value, showTextInput, textInputName, textInputValue }, index) => ({
          title,
          value,
          key: `textFields-${index}`,
          showTextInput,
          textInputName,
          textInputValue,
        })),
        textBlockFields.map((i, index) => ({ title: i.title, value: getValueTextBlock(i), key: `textBlockFields-${index}` })),
        formulaFields.map((i, index) => ({ title: i.title, value: getFormulaText(i), key: `formulaFields-${index}` })),
        timeFields.map((i, index) => ({ title: i.title, value: getValueTime(i), key: `timeFields-${index}` })),
        dateTimeFields.map((i, index) => ({ title: i.title, value: getValueDateTime(i), key: `dateTimeFields-${index}` })),
        locationFields.map((i, index) => ({ title: i.title, value: getValueLocation(i), key: `locationFields-${index}` })),
      ];

      masonry2 = masonry2.filter((i) => i.length);

      const baseURL = this.localBasePath + '/';

      const files = fileFields.map((i, index) => ({
        key: `File-${index}`,
        title: i.title,
        link: `${baseURL}api/v1/reports/report/${report.id}/files/${i.key}?authorization=${this.access_token_link}`,
      }));

      const medias = mediaFields.map((i, index) => ({
        key: `Media-${index}`,
        title: i.title,
        link: `${baseURL}api/v1/reports/report/${report.id}/files/${i.key}?authorization=${this.access_token_link}`,
      }));

      const signatures = signatureFields.map((i, index) => ({
        key: `Signature-${index}`,
        title: i.title,
        link: `${baseURL}api/v1/reports/report/${report.id}/files/${i.key}?authorization=${this.access_token_link}`,
      }));

      const feeds = [];
      if (feedFields.length) {
        const getIMG = (item) => {
          return `${localBasePath}/api/v1/reports/feed/message/${item.id || item._id}?authorization=${this.access_token_link}`;
        };

        const generateFeed = async () => {
          for (const item of feedFields) {
            const title = item.title;
            const messages = await this.getFeedMeesages(item.value);
            const feedMessages = [];
            for (const msg of messages) {
              if (msg.type === ENTRY_TYPES.TEXT) {
                feedMessages.push({
                  type: 'textImage',
                  message: msg.message,
                  link: msg.attachments && msg.attachments.length ? getIMG(msg.attachments[0]) : '',
                  key: msg.id,
                });

                if (msg.attachments && msg.attachments.length > 1) {
                  const att = [[]];
                  let count = 0;
                  let attIndex = 0;
                  msg.attachments.forEach((el, index) => {
                    if (index === 0) {
                      // first elemet always show with text
                      return;
                    }
                    att[attIndex].push(el);
                    count += 1;
                    if (count === 3 && index !== msg.attachments.length - 1) {
                      attIndex += 1;
                      att[attIndex] = [];
                      count = 0;
                    }
                  });
                  console.log(att, 'att');
                  for (const msgAtt of att) {
                    if (msgAtt.length) {
                      feedMessages.push({ type: 'images', links: msgAtt.map((i) => getIMG(i)), key: msg.id });
                    }
                  }
                }
              }
              if (msg.type.includes('image')) {
                feedMessages.push({ type: 'image', link: getIMG(msg), key: msg.id });
              }
            }
            feeds.push({ title, messages: feedMessages });
          }
        };
        await generateFeed();
      }
      return {
        masonry2,
        checkboxs: checkboxFields,
        multipleCheckbox: multipleCheckboxFields,
        radioButton: radioButtonFields,
        files,
        medias,
        signatures,
        feeds,
      };
    },
    async getReport() {
      const response = await this.reportsService.getReportById(this.$route.params.id);
      if (!response.data.user) {
        response.data.user = {};
      }
      this.report = response.data;
      return response;
    },
    async getFeedMeesages(id) {
      const response = await this.reportsService.getFeedMeesages(id);
      return response.data;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .main-content {
  font-family: 'Poppins', sans-serif;
}

::v-deep .zip-link {
  cursor: pointer;
  color: white;
  background: linear-gradient(#2260ff, #2260ff);
  border-radius: 4px;
  border: none;
  padding: 6px 12px;
  font-family: 'Poppins', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.5;
  display: inline-block;
  outline: none;
}

::v-deep .zip-link:hover {
  border: none;
  background: linear-gradient(180deg, #2260ff 0%, rgba(34, 96, 255, 0.75) 100%) !important;
  color: #fff;
  text-decoration: none;
}

::v-deep .masonry-2,
.masonry-3 {
  margin: 1em 0;
  padding: 0;
  column-gap: 1.5em; /* Общее расстояние между колонками */
  -moz-column-gap: 1.5em; /* Расстояние между колонками для Firefox */
  -webkit-column-gap: 1.5em; /* Расстояние между колонками  для Safari, Chrome и iOS */
}

/* Элементы в виде плиток с содержанием */
::v-deep .item {
  /* display: inline-block; */
  background: #fff;
  margin: 0 0 0.75em;
  width: 100%;
  page-break-inside: avoid;
}

/* Стили картинок, видое и фреймов внутри адаптивных плиток */
::v-deep img,
iframe {
  max-width: 90%;
  height: auto;
  display: block;
  margin-top: 10px;
  max-height: 150px;
}

/* Стили ссылок внутри плиток */
::v-deep .item a {
  text-decoration: none;
  color: #359cc6;
  margin: 0 5px;
}

/* Стили ссылок при наведении */
::v-deep .item a:hover {
  color: #e88f00;
  border-bottom: 1px dotted #9f1d35;
}

::v-deep .masonry-2 {
  -moz-column-count: 2;
  -webkit-column-count: 2;
  column-count: 2;
}
::v-deep .masonry-3 {
  -moz-column-count: 3;
  -webkit-column-count: 3;
  column-count: 3;
}

::v-deep .signature {
  page-break-inside: avoid;
}

::v-deep .group-block {
  margin-bottom: 30px;
}
::v-deep .group-name-block {
  margin-bottom: 10px;
  display: flex;
}
::v-deep .customer-logo-header {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
::v-deep .customer-logo-wrapper {
  width: 90%;
  height: 70px;
}
::v-deep .reports-logo {
  height: 70px;
  width: 70px;
  border-radius: 10px;
}
::v-deep .group-name {
  font-weight: bold;
  padding: 5px !important;
  background-color: rgb(208, 208, 208);
  font-size: 19px;
}
::v-deep .group-comment {
  font-style: italic;
  font-size: 12px;
}
::v-deep .group-field-name {
  font-weight: bold;
  margin-right: 5px;
  font-size: 14px;
}
::v-deep .group-field-comment {
  font-style: italic;
  font-size: 12px;
  margin-left: 5px;
}
::v-deep .group-multimedia-name {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
}
::v-deep .multimedia-line {
  border-bottom: 1px solid rgb(180, 180, 180);
  padding: 10px 0;
  page-break-inside: avoid;
}
::v-deep .multimedia-line-text {
  width: 100%;
}
::v-deep .multimedia-line-photo {
  width: 100%;
  display: flex;
  justify-content: flex-start;
}
::v-deep .multimedia-line-mylti-photo {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
::v-deep .multimedia-line-mylti-photo img,
.multimedia-line-photo img {
  max-height: 150px;
}
::v-deep .user-block {
  font-size: 13px;
  font-weight: 400;
}
::v-deep .date-text {
  margin-top: 5px;
}
::v-deep .date-text,
.page-number-text {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
::v-deep .report-text {
  width: 100%;
}
::v-deep #header {
  margin-bottom: 10px;
}
::v-deep .report-title {
  margin: 0;
  padding: 5px 0;
}
</style>
